import styled from 'styled-components';

import InteractiveLoader from '~/src/components/InteractiveLoader';

export const SInteractiveLoader = styled(InteractiveLoader)`
    flex: 1;
`;
